/**
 * Local-first favorites for recordings and videos. Uses localStorage —
 * no auth needed. Emits a `vaad:favorites-changed` custom event on every
 * mutation so open tabs / other components stay in sync.
 */

const KEY = 'vaad_favorites_v1';
const EVENT = 'vaad:favorites-changed';

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : { recording: {}, video: {} };
  } catch {
    return { recording: {}, video: {} };
  }
};

const write = (obj) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(obj));
  } catch { /* quota */ }
  try {
    window.dispatchEvent(new CustomEvent(EVENT));
  } catch { /* SSR safety */ }
};

export const isFavorited = (type, id) => {
  if (!id) return false;
  const all = read();
  return !!(all[type] && all[type][id]);
};

export const toggleFavorite = (type, item) => {
  if (!item) return false;
  const id = item.id || item.drive_file_id;
  if (!id) return false;
  const all = read();
  if (!all[type]) all[type] = {};
  if (all[type][id]) {
    delete all[type][id];
    write(all);
    return false;
  }
  all[type][id] = {
    id,
    title: item.title || item.name || 'Untitled',
    speaker: item.speaker || '',
    cover_image: item.cover_image || item.thumbnailLink || '',
    drive_file_id: item.drive_file_id || id,
    stream_url: item.stream_url,
    saved_at: Date.now(),
  };
  write(all);
  return true;
};

export const removeFavorite = (type, id) => {
  const all = read();
  if (all[type] && all[type][id]) {
    delete all[type][id];
    write(all);
  }
};

export const listFavorites = (type) => {
  const all = read();
  const items = Object.values(all[type] || {});
  items.sort((a, b) => (b.saved_at || 0) - (a.saved_at || 0));
  return items;
};

export const favoritesChangeEvent = EVENT;
